import { MapPin, Phone, Mail, Clock, MessageCircle, ShieldCheck } from "lucide-react";
import { SocialLinks } from "@/components/SocialLinks";
import { BUSINESS } from "@/lib/brand";
import { WA_MESSAGES, waLink } from "@/lib/api";

const Row = ({ icon: Icon, label, children, testId }) => (
  <div className="flex gap-4 py-5 border-b border-[#D5B98C]/40" data-testid={testId}>
    <Icon className="w-5 h-5 text-[#956842] shrink-0 mt-0.5" strokeWidth={1.5} />
    <div>
      <div className="text-[11px] uppercase tracking-[0.22em] text-[#956842] mb-1">{label}</div>
      <div className="text-[15px] text-[#242321] leading-relaxed">{children}</div>
    </div>
  </div>
);

export default function ContactsPage() {
  return (
    <div className="max-w-5xl mx-auto px-5 sm:px-8 pt-16" data-testid="info-page-contatti">
      <div className="text-[11px] uppercase tracking-[0.25em] text-[#956842] mb-3">Assistenza</div>
      <h1 data-testid="info-page-title" className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#39251D] leading-none">Contatti</h1>
      <p className="mt-6 text-base text-[#242321]/75 max-w-xl">Siamo a disposizione per informazioni sui prodotti, sugli ordini e sulle spedizioni.</p>
      <div className="mt-12 grid lg:grid-cols-[1.2fr_1fr] gap-12">
        <div>
          <Row icon={MapPin} label="Indirizzo" testId="contact-address">
            <a href={BUSINESS.mapsHref} target="_blank" rel="noopener noreferrer" className="hover:text-[#956842]">{BUSINESS.address}<br />{BUSINESS.city}</a>
          </Row>
          <Row icon={Phone} label="Telefono e WhatsApp" testId="contact-phone">
            <a href={BUSINESS.phoneHref} className="hover:text-[#956842]">{BUSINESS.phone}</a>
          </Row>
          <Row icon={Mail} label="Email" testId="contact-email">
            <a href={`mailto:${BUSINESS.email}`} className="hover:text-[#956842] break-all">{BUSINESS.email}</a>
          </Row>
          <Row icon={ShieldCheck} label="PEC" testId="contact-pec">
            <a href={`mailto:${BUSINESS.pec}`} className="hover:text-[#956842] break-all">{BUSINESS.pec}</a>
          </Row>
          <Row icon={Clock} label="Orari" testId="contact-hours">
            {BUSINESS.hours.map((h) => <div key={h.days}>{h.days}<br /><span className="text-[#242321]/70">{h.time}</span></div>)}
          </Row>
        </div>
        <div className="bg-[#39251D] text-[#F5F0E8] p-8 self-start relative grain">
          <div className="relative">
            <div className="font-serif text-3xl">Scrivici su WhatsApp</div>
            <p className="mt-2 text-sm text-[#F5F0E8]/70">Scegli l'argomento: il messaggio sarà già pronto.</p>
            <div className="mt-6 flex flex-col gap-2">
              {[["prodotto", "Info prodotto"], ["ordine", "Assistenza ordine"], ["spedizioni", "Info spedizioni"]].map(([k, l]) => (
                <a key={k} data-testid={`contact-whatsapp-${k}`} href={waLink(WA_MESSAGES[k])} target="_blank" rel="noopener noreferrer"
                  className="flex items-center gap-3 px-4 py-3 border border-[#D5B98C]/40 text-sm hover:bg-[#F5F0E8] hover:text-[#39251D] transition-colors">
                  <MessageCircle className="w-4 h-4" strokeWidth={1.5} /> {l}
                </a>
              ))}
            </div>
            <div className="mt-8 text-[11px] uppercase tracking-[0.22em] text-[#D5B98C]">Seguici</div>
            <SocialLinks className="mt-3" prefix="contact-social" />
          </div>
        </div>
      </div>
      <div className="mt-10 text-xs text-[#242321]/60 leading-relaxed" data-testid="contact-legal">
        <p><b>{BUSINESS.brand}</b> · by La Bottega del Calzolaio — marchio e-commerce di {BUSINESS.legalName}, {BUSINESS.legalForm}.</p>
        <p>Sede legale {BUSINESS.legalSeat} · Partita IVA {BUSINESS.vat} · C.F. {BUSINESS.cf} · REA {BUSINESS.rea}</p>
      </div>
    </div>
  );
}
